import React from 'react';
import { Button } from 'material-ui';
import { faSpinner } from '@fortawesome/fontawesome-free-solid'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import './client-buttons.scss'

const ClientButtons = ({isDeactivated, isDirect, disableSaveBtn, saveLoading, saveHandler, activateLoading, activateHandler, mutationRequest}) => {
    return (
        <div className='table-buttons client-buttons'>
            {
                isDirect &&
                    <Button 
                        color="secondary" 
                        variant="raised" 
                        className="save-btn"
                        disabled={disableSaveBtn}
                        onClick={saveHandler}
                    >
                    {
                        saveLoading 
                            ? <FontAwesomeIcon icon={faSpinner} spin />
                            : "save"
                    }      
                    </Button>
            }
            <Button 
                color="default" 
                variant="raised" 
                className={`deactivate-btn ${mutationRequest ? "request" : ""}`}
                onClick={activateHandler}
            >
                {
                    activateLoading 
                        ? <FontAwesomeIcon icon={faSpinner} spin />
                        : isDeactivated ? "activate" : "deactivate" 
                }
            </Button>
        </div>
    );
};

export default ClientButtons;